import React from 'react';
import {GenericReportingDropdowns} from '../../../containers/GenericReportingDropdowns';
import LtrTabDropdowns from "./LtrTabDropdowns";
import CohortTabDropdowns from "./CohortTabDropdowns";

export const ProductPerformancePageDropdowns = ({ tabKey }) => {
  const includeGranularity = tabKey === "1";

  function GetExtraDropdownsForTabs(tabKey) {
    switch (tabKey) {
      case "1":
        return <LtrTabDropdowns />;
      case "2":
        return <LtrTabDropdowns />;
      case "3":
        return <CohortTabDropdowns />;
      default:
        return null;
    }
  }

  return (
    <>
      <GenericReportingDropdowns
        includeDateRange={includeGranularity}
        includeGranularity={includeGranularity}
        includeSingleSelectRegion={true}
        includeTooltipsAndTitles={false}
        containerStyle="dropdown-container"
        renderAsButton={true}
        includeCompareDateRange={false}
        extraDropdowns={GetExtraDropdownsForTabs(tabKey)}
      />
    </>
  );
};

export default ProductPerformancePageDropdowns; 